import { Injectable } from '@angular/core';
import { ExportInterface } from 'app/models/export.model';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';

@Injectable({
  providedIn: 'root',
})
export class ExportDataTransformPost extends DataTransformAbstractPost {
  constructor(protected readonly _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(logExport: ExportInterface): ExportInterface {
    if (logExport.startAt) {
      logExport.startAt = this.normalizeDate(logExport.startAt.toString());
    }
    if (logExport.endAt) {
      logExport.endAt = this.normalizeDate(logExport.endAt.toString());
    }
    if (logExport.hourPoints) {
      logExport.hourPoints.systems = this.mapIds(logExport.hourPoints.systems);
      logExport.hourPoints.resources = this.mapIds(logExport.hourPoints.resources);
    }
    if (logExport.aggTime) {
      logExport.aggTime.systems = this.mapIds(logExport.aggTime.systems);
      logExport.aggTime.circuits = this.mapIds(logExport.aggTime.circuits);
      logExport.aggTime.resources = this.mapIds(logExport.aggTime.resources);
    }
    if (logExport.aggSystem) {
      logExport.aggSystem.systems = this.mapIds(logExport.aggSystem.systems);
      logExport.aggSystem.circuits = this.mapIds(logExport.aggSystem.circuits);
      logExport.aggSystem.resources = this.mapIds(logExport.aggSystem.resources);
    }
    if (logExport.aggContent) {
      logExport.aggContent.systems = this.mapIds(logExport.aggContent.systems);
      logExport.aggContent.circuits = this.mapIds(logExport.aggContent.circuits);
      logExport.aggContent.resources = this.mapIds(logExport.aggContent.resources);
    }
    return logExport;
  }
}
